// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/billing.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "api.devplan.types.billing";

/** Single time-series data point representing usage at a specific time */
export interface UsageDataPoint {
  startsAt: Date | undefined;
  endsAt: Date | undefined;
  creditsUsage: number;
}

/** Summary metrics aggregated over the requested time range */
export interface UsageSummary {
  /** Minimum usage value in the range */
  min: number;
  /** Maximum usage value in the range */
  max: number;
  /** Current/most recent usage value */
  current: number;
  /** Total cumulative usage across the range */
  total: number;
}

export interface OrganizationCreditPlanState {
  orgId: string;
  subscriptionId: string;
  status: string;
  currentAmountDollars: number;
  pendingAmountDollars: number;
  currentPeriodEnd: Date | undefined;
  cancelAtPeriodEnd: boolean;
  pendingEffectiveAt: Date | undefined;
}

/** Represents a single line item from a Stripe invoice */
export interface InvoiceLine {
  /** Stripe line item ID */
  id: string;
  /** Description of the line item (e.g., "Professional Plan - Jan 2025") */
  description?:
    | string
    | undefined;
  /** Amount in cents (e.g., 2999 for $29.99) */
  amount?:
    | number
    | undefined;
  /** Quantity of the item */
  quantity?:
    | number
    | undefined;
  /** Currency code (e.g., "usd") */
  currency?:
    | string
    | undefined;
  /** Discount amount in cents for this line item */
  discountAmount?:
    | number
    | undefined;
  /** Discount description (e.g., "50% off") */
  discountDescription?: string | undefined;
}

/** Complete invoice preview data structure */
export interface InvoicePreview {
  /** Line items on the invoice */
  lines: InvoiceLine[];
  /** Subtotal amount in cents (before tax and discounts) */
  subtotalAmount?:
    | number
    | undefined;
  /** Total amount in cents (final amount to be charged) */
  totalAmount?:
    | number
    | undefined;
  /** Total tax amount in cents */
  taxAmount?:
    | number
    | undefined;
  /** Total discount amount in cents */
  discountAmount?:
    | number
    | undefined;
  /** Currency code (e.g., "usd") */
  currency?:
    | string
    | undefined;
  /** Next payment attempt timestamp */
  nextPaymentDate?: Date | undefined;
}

function createBaseUsageDataPoint(): UsageDataPoint {
  return { startsAt: undefined, endsAt: undefined, creditsUsage: 0 };
}

export const UsageDataPoint: MessageFns<UsageDataPoint> = {
  encode(message: UsageDataPoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.startsAt !== undefined) {
      Timestamp.encode(toTimestamp(message.startsAt), writer.uint32(10).fork()).join();
    }
    if (message.endsAt !== undefined) {
      Timestamp.encode(toTimestamp(message.endsAt), writer.uint32(18).fork()).join();
    }
    if (message.creditsUsage !== 0) {
      writer.uint32(24).int64(message.creditsUsage);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UsageDataPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUsageDataPoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.startsAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.endsAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.creditsUsage = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UsageDataPoint {
    return {
      startsAt: isSet(object.startsAt)
        ? fromJsonTimestamp(object.startsAt)
        : isSet(object.starts_at)
        ? fromJsonTimestamp(object.starts_at)
        : undefined,
      endsAt: isSet(object.endsAt)
        ? fromJsonTimestamp(object.endsAt)
        : isSet(object.ends_at)
        ? fromJsonTimestamp(object.ends_at)
        : undefined,
      creditsUsage: isSet(object.creditsUsage)
        ? globalThis.Number(object.creditsUsage)
        : isSet(object.credits_usage)
        ? globalThis.Number(object.credits_usage)
        : 0,
    };
  },

  toJSON(message: UsageDataPoint): unknown {
    const obj: any = {};
    if (message.startsAt !== undefined) {
      obj.startsAt = message.startsAt.toISOString();
    }
    if (message.endsAt !== undefined) {
      obj.endsAt = message.endsAt.toISOString();
    }
    if (message.creditsUsage !== 0) {
      obj.creditsUsage = Math.round(message.creditsUsage);
    }
    return obj;
  },

  create(base?: DeepPartial<UsageDataPoint>): UsageDataPoint {
    return UsageDataPoint.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UsageDataPoint>): UsageDataPoint {
    const message = createBaseUsageDataPoint();
    message.startsAt = object.startsAt ?? undefined;
    message.endsAt = object.endsAt ?? undefined;
    message.creditsUsage = object.creditsUsage ?? 0;
    return message;
  },
};

function createBaseUsageSummary(): UsageSummary {
  return { min: 0, max: 0, current: 0, total: 0 };
}

export const UsageSummary: MessageFns<UsageSummary> = {
  encode(message: UsageSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.min !== 0) {
      writer.uint32(8).int64(message.min);
    }
    if (message.max !== 0) {
      writer.uint32(16).int64(message.max);
    }
    if (message.current !== 0) {
      writer.uint32(24).int64(message.current);
    }
    if (message.total !== 0) {
      writer.uint32(32).int64(message.total);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UsageSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUsageSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.min = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.max = longToNumber(reader.int64());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.current = longToNumber(reader.int64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.total = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UsageSummary {
    return {
      min: isSet(object.min) ? globalThis.Number(object.min) : 0,
      max: isSet(object.max) ? globalThis.Number(object.max) : 0,
      current: isSet(object.current) ? globalThis.Number(object.current) : 0,
      total: isSet(object.total) ? globalThis.Number(object.total) : 0,
    };
  },

  toJSON(message: UsageSummary): unknown {
    const obj: any = {};
    if (message.min !== 0) {
      obj.min = Math.round(message.min);
    }
    if (message.max !== 0) {
      obj.max = Math.round(message.max);
    }
    if (message.current !== 0) {
      obj.current = Math.round(message.current);
    }
    if (message.total !== 0) {
      obj.total = Math.round(message.total);
    }
    return obj;
  },

  create(base?: DeepPartial<UsageSummary>): UsageSummary {
    return UsageSummary.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UsageSummary>): UsageSummary {
    const message = createBaseUsageSummary();
    message.min = object.min ?? 0;
    message.max = object.max ?? 0;
    message.current = object.current ?? 0;
    message.total = object.total ?? 0;
    return message;
  },
};

function createBaseOrganizationCreditPlanState(): OrganizationCreditPlanState {
  return {
    orgId: "",
    subscriptionId: "",
    status: "",
    currentAmountDollars: 0,
    pendingAmountDollars: 0,
    currentPeriodEnd: undefined,
    cancelAtPeriodEnd: false,
    pendingEffectiveAt: undefined,
  };
}

export const OrganizationCreditPlanState: MessageFns<OrganizationCreditPlanState> = {
  encode(message: OrganizationCreditPlanState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.subscriptionId !== "") {
      writer.uint32(18).string(message.subscriptionId);
    }
    if (message.status !== "") {
      writer.uint32(26).string(message.status);
    }
    if (message.currentAmountDollars !== 0) {
      writer.uint32(32).int32(message.currentAmountDollars);
    }
    if (message.pendingAmountDollars !== 0) {
      writer.uint32(40).int32(message.pendingAmountDollars);
    }
    if (message.currentPeriodEnd !== undefined) {
      Timestamp.encode(toTimestamp(message.currentPeriodEnd), writer.uint32(50).fork()).join();
    }
    if (message.cancelAtPeriodEnd !== false) {
      writer.uint32(56).bool(message.cancelAtPeriodEnd);
    }
    if (message.pendingEffectiveAt !== undefined) {
      Timestamp.encode(toTimestamp(message.pendingEffectiveAt), writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrganizationCreditPlanState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrganizationCreditPlanState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.subscriptionId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.currentAmountDollars = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.pendingAmountDollars = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.currentPeriodEnd = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.cancelAtPeriodEnd = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.pendingEffectiveAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrganizationCreditPlanState {
    return {
      orgId: isSet(object.orgId)
        ? globalThis.String(object.orgId)
        : isSet(object.org_id)
        ? globalThis.String(object.org_id)
        : "",
      subscriptionId: isSet(object.subscriptionId)
        ? globalThis.String(object.subscriptionId)
        : isSet(object.subscription_id)
        ? globalThis.String(object.subscription_id)
        : "",
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      currentAmountDollars: isSet(object.currentAmountDollars)
        ? globalThis.Number(object.currentAmountDollars)
        : isSet(object.current_amount_dollars)
        ? globalThis.Number(object.current_amount_dollars)
        : 0,
      pendingAmountDollars: isSet(object.pendingAmountDollars)
        ? globalThis.Number(object.pendingAmountDollars)
        : isSet(object.pending_amount_dollars)
        ? globalThis.Number(object.pending_amount_dollars)
        : 0,
      currentPeriodEnd: isSet(object.currentPeriodEnd)
        ? fromJsonTimestamp(object.currentPeriodEnd)
        : isSet(object.current_period_end)
        ? fromJsonTimestamp(object.current_period_end)
        : undefined,
      cancelAtPeriodEnd: isSet(object.cancelAtPeriodEnd)
        ? globalThis.Boolean(object.cancelAtPeriodEnd)
        : isSet(object.cancel_at_period_end)
        ? globalThis.Boolean(object.cancel_at_period_end)
        : false,
      pendingEffectiveAt: isSet(object.pendingEffectiveAt)
        ? fromJsonTimestamp(object.pendingEffectiveAt)
        : isSet(object.pending_effective_at)
        ? fromJsonTimestamp(object.pending_effective_at)
        : undefined,
    };
  },

  toJSON(message: OrganizationCreditPlanState): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.subscriptionId !== "") {
      obj.subscriptionId = message.subscriptionId;
    }
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.currentAmountDollars !== 0) {
      obj.currentAmountDollars = Math.round(message.currentAmountDollars);
    }
    if (message.pendingAmountDollars !== 0) {
      obj.pendingAmountDollars = Math.round(message.pendingAmountDollars);
    }
    if (message.currentPeriodEnd !== undefined) {
      obj.currentPeriodEnd = message.currentPeriodEnd.toISOString();
    }
    if (message.cancelAtPeriodEnd !== false) {
      obj.cancelAtPeriodEnd = message.cancelAtPeriodEnd;
    }
    if (message.pendingEffectiveAt !== undefined) {
      obj.pendingEffectiveAt = message.pendingEffectiveAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<OrganizationCreditPlanState>): OrganizationCreditPlanState {
    return OrganizationCreditPlanState.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<OrganizationCreditPlanState>): OrganizationCreditPlanState {
    const message = createBaseOrganizationCreditPlanState();
    message.orgId = object.orgId ?? "";
    message.subscriptionId = object.subscriptionId ?? "";
    message.status = object.status ?? "";
    message.currentAmountDollars = object.currentAmountDollars ?? 0;
    message.pendingAmountDollars = object.pendingAmountDollars ?? 0;
    message.currentPeriodEnd = object.currentPeriodEnd ?? undefined;
    message.cancelAtPeriodEnd = object.cancelAtPeriodEnd ?? false;
    message.pendingEffectiveAt = object.pendingEffectiveAt ?? undefined;
    return message;
  },
};

function createBaseInvoiceLine(): InvoiceLine {
  return {
    id: "",
    description: undefined,
    amount: undefined,
    quantity: undefined,
    currency: undefined,
    discountAmount: undefined,
    discountDescription: undefined,
  };
}

export const InvoiceLine: MessageFns<InvoiceLine> = {
  encode(message: InvoiceLine, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.description !== undefined) {
      writer.uint32(18).string(message.description);
    }
    if (message.amount !== undefined) {
      writer.uint32(24).int64(message.amount);
    }
    if (message.quantity !== undefined) {
      writer.uint32(32).int64(message.quantity);
    }
    if (message.currency !== undefined) {
      writer.uint32(42).string(message.currency);
    }
    if (message.discountAmount !== undefined) {
      writer.uint32(48).int64(message.discountAmount);
    }
    if (message.discountDescription !== undefined) {
      writer.uint32(58).string(message.discountDescription);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InvoiceLine {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInvoiceLine();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.amount = longToNumber(reader.int64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.quantity = longToNumber(reader.int64());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.currency = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.discountAmount = longToNumber(reader.int64());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.discountDescription = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InvoiceLine {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      amount: isSet(object.amount) ? globalThis.Number(object.amount) : undefined,
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : undefined,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : undefined,
      discountAmount: isSet(object.discountAmount)
        ? globalThis.Number(object.discountAmount)
        : isSet(object.discount_amount)
        ? globalThis.Number(object.discount_amount)
        : undefined,
      discountDescription: isSet(object.discountDescription)
        ? globalThis.String(object.discountDescription)
        : isSet(object.discount_description)
        ? globalThis.String(object.discount_description)
        : undefined,
    };
  },

  toJSON(message: InvoiceLine): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.amount !== undefined) {
      obj.amount = Math.round(message.amount);
    }
    if (message.quantity !== undefined) {
      obj.quantity = Math.round(message.quantity);
    }
    if (message.currency !== undefined) {
      obj.currency = message.currency;
    }
    if (message.discountAmount !== undefined) {
      obj.discountAmount = Math.round(message.discountAmount);
    }
    if (message.discountDescription !== undefined) {
      obj.discountDescription = message.discountDescription;
    }
    return obj;
  },

  create(base?: DeepPartial<InvoiceLine>): InvoiceLine {
    return InvoiceLine.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<InvoiceLine>): InvoiceLine {
    const message = createBaseInvoiceLine();
    message.id = object.id ?? "";
    message.description = object.description ?? undefined;
    message.amount = object.amount ?? undefined;
    message.quantity = object.quantity ?? undefined;
    message.currency = object.currency ?? undefined;
    message.discountAmount = object.discountAmount ?? undefined;
    message.discountDescription = object.discountDescription ?? undefined;
    return message;
  },
};

function createBaseInvoicePreview(): InvoicePreview {
  return {
    lines: [],
    subtotalAmount: undefined,
    totalAmount: undefined,
    taxAmount: undefined,
    discountAmount: undefined,
    currency: undefined,
    nextPaymentDate: undefined,
  };
}

export const InvoicePreview: MessageFns<InvoicePreview> = {
  encode(message: InvoicePreview, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.lines) {
      InvoiceLine.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.subtotalAmount !== undefined) {
      writer.uint32(16).int64(message.subtotalAmount);
    }
    if (message.totalAmount !== undefined) {
      writer.uint32(24).int64(message.totalAmount);
    }
    if (message.taxAmount !== undefined) {
      writer.uint32(32).int64(message.taxAmount);
    }
    if (message.discountAmount !== undefined) {
      writer.uint32(40).int64(message.discountAmount);
    }
    if (message.currency !== undefined) {
      writer.uint32(50).string(message.currency);
    }
    if (message.nextPaymentDate !== undefined) {
      Timestamp.encode(toTimestamp(message.nextPaymentDate), writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InvoicePreview {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInvoicePreview();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.lines.push(InvoiceLine.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.subtotalAmount = longToNumber(reader.int64());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.totalAmount = longToNumber(reader.int64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.taxAmount = longToNumber(reader.int64());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.discountAmount = longToNumber(reader.int64());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.currency = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.nextPaymentDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InvoicePreview {
    return {
      lines: globalThis.Array.isArray(object?.lines) ? object.lines.map((e: any) => InvoiceLine.fromJSON(e)) : [],
      subtotalAmount: isSet(object.subtotalAmount)
        ? globalThis.Number(object.subtotalAmount)
        : isSet(object.subtotal_amount)
        ? globalThis.Number(object.subtotal_amount)
        : undefined,
      totalAmount: isSet(object.totalAmount)
        ? globalThis.Number(object.totalAmount)
        : isSet(object.total_amount)
        ? globalThis.Number(object.total_amount)
        : undefined,
      taxAmount: isSet(object.taxAmount)
        ? globalThis.Number(object.taxAmount)
        : isSet(object.tax_amount)
        ? globalThis.Number(object.tax_amount)
        : undefined,
      discountAmount: isSet(object.discountAmount)
        ? globalThis.Number(object.discountAmount)
        : isSet(object.discount_amount)
        ? globalThis.Number(object.discount_amount)
        : undefined,
      currency: isSet(object.currency) ? globalThis.String(object.currency) : undefined,
      nextPaymentDate: isSet(object.nextPaymentDate)
        ? fromJsonTimestamp(object.nextPaymentDate)
        : isSet(object.next_payment_date)
        ? fromJsonTimestamp(object.next_payment_date)
        : undefined,
    };
  },

  toJSON(message: InvoicePreview): unknown {
    const obj: any = {};
    if (message.lines?.length) {
      obj.lines = message.lines.map((e) => InvoiceLine.toJSON(e));
    }
    if (message.subtotalAmount !== undefined) {
      obj.subtotalAmount = Math.round(message.subtotalAmount);
    }
    if (message.totalAmount !== undefined) {
      obj.totalAmount = Math.round(message.totalAmount);
    }
    if (message.taxAmount !== undefined) {
      obj.taxAmount = Math.round(message.taxAmount);
    }
    if (message.discountAmount !== undefined) {
      obj.discountAmount = Math.round(message.discountAmount);
    }
    if (message.currency !== undefined) {
      obj.currency = message.currency;
    }
    if (message.nextPaymentDate !== undefined) {
      obj.nextPaymentDate = message.nextPaymentDate.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<InvoicePreview>): InvoicePreview {
    return InvoicePreview.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<InvoicePreview>): InvoicePreview {
    const message = createBaseInvoicePreview();
    message.lines = object.lines?.map((e) => InvoiceLine.fromPartial(e)) || [];
    message.subtotalAmount = object.subtotalAmount ?? undefined;
    message.totalAmount = object.totalAmount ?? undefined;
    message.taxAmount = object.taxAmount ?? undefined;
    message.discountAmount = object.discountAmount ?? undefined;
    message.currency = object.currency ?? undefined;
    message.nextPaymentDate = object.nextPaymentDate ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
